import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import NumberTextModule from "@modules/NumberTextModule"

const WithMetaloop = ({ extraClasses = {} }) => {
  const { t } = useTranslation()

  const nums = [
    {
      number: 1,
      description: t("AboutMetaloop_Step1"),
      isLast: false,
    },
    {
      number: 2,
      description: t("AboutMetaloop_Step2"),
      isLast: false,
    },
    {
      number: 3,
      description: t("AboutMetaloop_Step3"),
      isLast: false,
    },
    {
      number: 4,
      description: t("AboutMetaloop_Step4"),
      isLast: false,
    },
    {
      number: 5,
      description: t("AboutMetaloop_Step5"),
      isLast: true,
    },
  ]

  return (
    <NumberTextModule
      title={t("AboutMetaloop_Section3")}
      numbers={nums}
      extraClasses={extraClasses}
    />
  )
}

export default WithMetaloop
